module.exports = __webpack_public_path__ + "static/img/x-level-1.d7c6f04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/x-level-1.svg
// module id = k+ti
// module chunks = 66